import {
  type Pagination,
  type PaginationData,
  type ProgramEventInvitee,
  createProgramEventInvitee,
  isRegisteredProgramInvitee,
} from 'models';
import { useInfiniteQuery } from 'query';
import type { ApiClientResponseError, DefaultResponseErrorDataObject } from 'common/services';
import { getEventInvitees } from '../services';
import type { EventsInviteesFilter } from '../types';
import { getEventsInviteesInfiniteQueryKey } from './keys';

type P = {
  filter: EventsInviteesFilter;
  pagination: Omit<Pagination, 'position'>;
};

export const useEventInviteesInfiniteQuery = ({ filter, pagination }: P) =>
  useInfiniteQuery<
    PaginationData<ProgramEventInvitee>,
    string | undefined,
    ApiClientResponseError<DefaultResponseErrorDataObject>
  >({
    async queryFn({ pageParam: cursor }) {
      const response = await getEventInvitees({
        config: {
          params: {
            cursor,
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
            event_role: filter?.role,
            limit: pagination.pageSize,
            order: 'created_at',
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
            search: filter?.search,
            sort: 'desc',
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
            status: filter?.status ?? 'all',
          },
        },
        routeParams: {
          id: filter.eventId,
        },
      });

      return {
        data: response.data.data.map((invitee) => createProgramEventInvitee(invitee)),
        total: response.data.total,
      };
    },
    initialPageParam: undefined,
    getNextPageParam(lastPage, allPages) {
      if (allPages.length * pagination.pageSize >= lastPage.total) {
        return undefined;
      }

      const lastInvitee = lastPage.data.at(-1);
      return isRegisteredProgramInvitee(lastInvitee) ? lastInvitee.id : undefined;
    },
    queryKey: getEventsInviteesInfiniteQueryKey({ filter, pagination }),
    refetchOnMount: 'always',
  });
